module.exports = __webpack_public_path__ + "static/media/icon_LQB.7bef0a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_LQB.png
// module id = 271
// module chunks = 0 1